import type { Location, NavigateFunction } from 'react-router-dom'

// Build a stable "from" string from the current location
export function buildFrom(location: Location): string {
  return location.pathname + (location.search || '')
}

// Navigate to cooking mode while preserving origin
export function goToCook(
  navigate: NavigateFunction,
  location: Location,
  recipeId: string
): void {
  navigate(`/cook/${recipeId}` as any, { state: { from: buildFrom(location) } })
}

// Navigate back to origin (history back preferred, then from, then fallback)
export function goBackToOrigin(
  navigate: NavigateFunction,
  location: Location,
  fallback: string = '/discover'
): void {
  const from = (location.state as any)?.from as string | undefined
  if (typeof window !== 'undefined' && window.history.length > 1) {
    navigate(-1)
    return
  }
  if (from) {
    navigate(from, { replace: true })
    return
  }
  navigate(fallback, { replace: true })
}

